import listenerMiddleware from "App/listenerMiddleware";
import userActionTypes from "Areas/Settings/users/redux/actionTypes";
import sidebarDocumentsActionTypes from "Areas/Sidebar/Documents/redux/actionTypes";
import map from "lodash/map";
import { createStore } from "redux";
import actionCreators from "./actionCreators";
import reducer, { initialState } from "./reducer";
const store = createStore(reducer, initialState);
export default store;
listenerMiddleware.addListener({
    [userActionTypes.GET_USERS_COMPLETED]: (action) => {
        store.dispatch(actionCreators.setAvatarData(action.payload));
    },
    [userActionTypes.REMOVE_USERS_COMPLETED]: action => {
        store.dispatch(actionCreators.removeAvatarData(action.meta));
    },
    [userActionTypes.GET_SELF_COMPLETED]: (action) => {
        store.dispatch(actionCreators.setAvatarData([action.payload]));
    },
    [userActionTypes.SAVE_USER_COMPLETED]: (action) => {
        store.dispatch(actionCreators.setAvatarData([action.payload]));
    },
    [sidebarDocumentsActionTypes.GET_TASKS_COMPLETED]: (action) => {
        store.dispatch(actionCreators.setAvatarData(map(action.payload, "User")));
    },
    [sidebarDocumentsActionTypes.GET_REQUEST_TASK_COMPLETED]: (action) => {
        action.payload.User && store.dispatch(actionCreators.setAvatarData([action.payload.User]));
    }
});
